
const getQueryString = (name) => {
  // var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
  // var r = window.location.search.substr(1).match(reg); 
  // if (r != null) return unescape(r[2]); 
  // return null; 
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  if (window.location.hash.indexOf("?") < 0) {
    return null;
  }
  let r = window.location.hash.split("?")[1].match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

export default getQueryString;